import { Component, Inject, OnInit, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TableauService } from 'src/app/api/services/tableau.service';
import { AuthService } from 'src/app/auth/services/auth.service';
import { Settings } from 'src/app/auth/models/settings';

declare var tableau: any;

@Component({
    selector: 'app-tableau-dialog',
    templateUrl: './tableau-dialog.component.html',
    styleUrls: ['./tableau-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TableauDialogComponent implements OnInit {
  public vizUrl: string;
  public token: string;
  public parameters: { name: string, value: string }[];
  public isTokenFetched: boolean;
  public codigosAnf: string = '';


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { anfcondeparam: string; codprodutoparam: string, software: string },
    private tableauService: TableauService,
    private authService: AuthService,
    private cdr: ChangeDetectorRef
  ) {
    // console.log('Dialog Data:', this.data);
    const initialUrl = 'https://dub01.online.tableau.com/t/pharmadata'
    let lastUrl = '';

      if (this.data.software === 'Winphar') {
        lastUrl = '/views/GraficoEVOLVEndas_17364840195440/evolvendas_1';
      } else if (this.data.software === 'Sifarma') {
        lastUrl = '/views/GraficoEVOLVEndas_17364840195440/evolvendasglintt';
      }
    this.vizUrl = initialUrl + lastUrl;;
    this.token = '';
    this.parameters = [
      { name: 'anfcondeparam', value: this.data.anfcondeparam },
      { name: 'codproduto', value: this.data.codprodutoparam },
    ];
    this.isTokenFetched = false;
  }

  ngOnInit(): void {
    this.authService.userSettings$.subscribe((settings: Settings | null) => {
      if (settings) {
        this.codigosAnf = settings.codigosAnf;
        this.updateParameters();
      }
    });
    this.getJwtToken();
  }

  private updateParameters(): void {
    this.parameters = [
      { name: 'anfcondeparam', value: this.data.anfcondeparam },
      { name: 'codproduto', value: this.data.codprodutoparam },
      { name: 'anfall', value: this.codigosAnf },
    ];
  }

  getJwtToken(): void {
    this.tableauService.getJwtToken().subscribe((response) => {
      this.token = response.token;
      this.isTokenFetched = true;
      this.cdr.detectChanges();
    });
  }
}